import { useState } from 'react'

/** Colors and border thickness shown in the Appearance section — local UI state only, never persisted. */
export function useAppearanceState() {
  const [borderThickness, setBorderThickness] = useState([0])
  const [colors, setColors] = useState({ fill: '#f0f0f0', stroke: '#ffffff' })

  return { borderThickness, setBorderThickness, colors, setColors }
}
